import axios from 'axios'
import { ElMessage } from 'element-plus'
import store from '../store'
import router from '../router'
import {isTokenExpired, removeToken} from "@/utils/auth";

// 创建axios实例
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API || '/',
  timeout: 10000,
  transformResponse: [function (data) {
    try {
      // 使用自定义的 JSON 解析器来处理大整数
      return parseJsonWithBigInt(data)
    } catch (e) {
      return data
    }
  }]
})

// 自定义 JSON 解析器，将大整数转换为字符串
function parseJsonWithBigInt(jsonString) {
  // 匹配 JSON 中的数字（包括负数、小数、科学计数法）
  // 但排除已经是字符串的数字
  const regex = /"(?:[^"\\]|\\.)*"|(\d{15,})/g
  
  const result = jsonString.replace(regex, (match, number) => {
    if (number) {
      // 如果是超过安全整数范围的数字，将其转换为字符串
      const num = Number(number)
      if (num > Number.MAX_SAFE_INTEGER || num < Number.MIN_SAFE_INTEGER) {
        return '"' + number + '"'
      }
    }
    return match
  })
  
  return JSON.parse(result)
}

// 请求拦截器
service.interceptors.request.use(
  config => {



    // 添加租户ID
    if (store.state.tenantId) {
      config.headers['X-Tenant-Id'] = store.state.tenantId
    }
    
    // 添加token
    if (store.state.token) {
        if (store.state.token) {
            // 请求前检查 Token 是否过期
            if (isTokenExpired()) {
                // 过期处理
                removeToken()
                store.commit('SET_TOKEN', '')
                ElMessage.error('登录已过期，请重新登录')
                router.push('/login')
                return Promise.reject(new Error('Token 已过期'))
            }
        }
      config.headers['Authorization'] = 'Bearer ' + store.state.token
    }
    return config
  },
  error => {
    // 处理请求错误
    console.error('request error:', error)
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    const res = response.data
    return res
  },
  error => {
    console.error('response error:', error)
    
    // 处理401未授权
    if (error.response && error.response.status === 401) {
      store.dispatch('logout')
      router.push('/login')
      ElMessage.error('登录已过期，请重新登录')
    } else {
      ElMessage.error(error.response?.data?.message || '操作失败')
    }
    
    return Promise.reject(error)
  }
)

export default service
